module.exports = __webpack_public_path__ + "c86995a6bce11ac02a56d9393d72250b.svg";